import type { LucideIcon } from 'lucide-react';
import { cn } from '../lib/cn';
import { MODULE_ICON, type Module } from '../lib/modules';

const SIZES = {
  xs: { tile: 'size-5', icon: 'size-3' },
  sm: { tile: 'size-6', icon: 'size-3.5' },
  md: { tile: 'size-8', icon: 'size-4' },
  lg: { tile: 'size-11', icon: 'size-5' },
};

/**
 * A module's icon in its colour: a pastel round tile (`tile`), or only the
 * coloured glyph (`bare`, e.g. in tabs). `kind` is a view kind or module name.
 */
export function ModuleIcon({
  kind,
  module,
  icon,
  size = 'sm',
  bare = false,
  className,
}: {
  kind?: string;
  module?: Module;
  icon?: LucideIcon;
  size?: keyof typeof SIZES;
  bare?: boolean;
  className?: string;
}) {
  const known = kind ? MODULE_ICON[kind] : undefined;
  const Icon = icon ?? known?.icon ?? MODULE_ICON.page!.icon;
  const mod = module ?? known?.module ?? 'neutral';
  const s = SIZES[size];
  if (bare)
    return <Icon aria-hidden className={cn(`mod-${mod} mod-ink shrink-0`, s.icon, className)} />;
  return (
    <span aria-hidden className={cn(`mod-${mod} mod-icon`, s.tile, className)}>
      <Icon className={s.icon} />
    </span>
  );
}
